import { render, staticRenderFns } from "./SerieNumeroFormGeneral.vue?vue&type=template&id=68ce2fcb&"
import script from "./SerieNumeroFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68ce2fcb', component.options)
    } else {
      api.reload('68ce2fcb', component.options)
    }
    module.hot.accept("./SerieNumeroFormGeneral.vue?vue&type=template&id=68ce2fcb&", function () {
      api.rerender('68ce2fcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerieActiva/SerieNumeroFormGeneral.vue"
export default component.exports